import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBulkUpdatesConfirmation extends Layout {
    checkboxConfirmVoid: Checkbox;
    sourceSettlement: DataSource;
    textboxStatus: Textbox;
}
